import { UNKNOWN_MARKER } from './capabilityFormat';
import type { EffectivePrice } from '@services/aiModelsService';

/** The schema coerces Decimal strings to numbers. `2.20 / 11.00 (bundled)`, or the unknown marker when the model has no price. */
export function formatEffectivePrice(price: EffectivePrice | null | undefined): string {
  if (!price) return UNKNOWN_MARKER;
  return `${price.input_per_mtok.toFixed(2)} / ${price.output_per_mtok.toFixed(2)} (${price.source})`;
}
